<template>
  <div class="container-fluid">
    <h2>CMS UI Manager: {{ workLabels[workarea] }}</h2>
    <hr/>
    <div class="row">
      <div class="col" style="max-width:300px;">
        <h4>Verzeichnisse</h4>
        <CTreeView v-if="workarea" @selectnode="updateList" :treeid="workarea"/>
      </div>
      <div class="col-9">
        <div role="toolbar" class="btn-toolbar justify-content-between">
          <div class="btn-group">
            <button @click="prevPage" class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
            <button @click="nextPage" class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
          </div>
          <b-dropdown text="Neues Dokument">
            <b-dropdown-item @click="addCMSDocument()">Standard</b-dropdown-item>
            <!-- <b-dropdown-item @click="addCMSReport()">Bericht</b-dropdown-item>
            <b-dropdown-item @click="addCMSFormular()">Formular</b-dropdown-item> -->
          </b-dropdown>
          <button v-if="workarea == 'firm-ui' || workarea == 'ihand-ui'" @click="openComponents" class="btn btn-primary">Komponenten</button>
          <button @click="openResources" class="btn btn-primary">Resourcen</button>
        </div>
        <b-table class="mt-3" id="docTable" :fields="fields" :items="rows">
          <template v-slot:cell(docType)="data">
            <span v-if="data.item.docType == 0">Normal</span>
            <span v-if="data.item.docType == 1">Bericht</span>
            <span v-if="data.item.docType == 2">Formular</span>
          </template>
          <template v-slot:cell(action)="data">
            <div class="btn-group">
              <button @click="openDocument(data.item)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
              <button @click="deleteDocument(data.item)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import cmsdocs from '@/modules/cmsdocs.js'
import CTreeView from '@/components/tree/CTreeView.vue'

export default {
  name: 'UIManager',
  components: {
    CTreeView,
  },
  data() {
    return {
      workLabels: {
        'ihand-ui':'iHand Home',
        'firm-ui':'Firma',
        'firmuser-ui':'Firmen Mitarbeiter',
        'ihanduser-ui':'iHand Vertreter',
        'ihandcustomer-ui':'iHand Kunden'
      },
      workarea: false,
      rows: [],
      start: 0,
      count: 20,
      catID: 0,
      fields: [
        { "key": "id", "label": "ID" },
        { "key": "title", "label":"Titel" },
        { "key": "label", "label":"Datei" },
        { "key": "docType", "label":"Typ"},
        { "key": "action", "label":"Aktion"}

      ]
    }
  },
  mounted() {
    console.log('area',this.$route);
    if (this.$route.params.area) {
       this.workarea = this.$route.params.area;
       console.log('update workarea:',this.workarea);
    }
    // this.fetchData.bind(this);
    this.fetchData();
  },
  methods: {
    openResources() {
      router.push({ name: 'CMSResourceManager', params: {area: this.workarea }});
    },
    async fetchData() {
      var data = await cmsdocs.list(this.catID,this.workarea,this.start,this.count);
      console.log('cms list',data,this);
      this.rows = data;
    },
    updateList(node) {
      console.log('node select',node);
      if (node) {
        this.catID = node.id;
        this.fetchData();
      }
    },

    addCMSDocument() {
      router.push({ name: 'CMSPageEditor', params: {tree: this.workarea,catid: this.catID, docid: 0}})
    },

    addCMSReport() {

    },
    addCMSFormular() {

    },
    deleteDocument(doc) {
      if (doc.docType == 0) {
        console.log('delete cms document',doc.id);
        if (!confirm('Möchten Sie das Dokument "' + doc.label + '" wirklich löschen?')) {
          return;
        }
        cmsdocs.deleteDocument(doc.id);
        this.fetchData();
      } else {
        console.error('Delete not implemented for type',doc.docType);
      }
    },

    prevPage() {
      if (this.start > 0) {
        this.start = Math.max(0,this.start - this.count);
        //this.fetchData();
      }
    },
    nextPage() {
      this.start += this.count;
      //this.fetchData();
    },

    openDocument(item) {
      console.log('open doc',item);
      router.push({ name: 'CMSPageEditor', params: {tree: this.workarea,catid: item.catID, docid: item.id}})
    },

    openComponents() {
      router.push({ name: 'CMSComponentManager', params: {area: this.workarea }});
    }

  }
}
</script>
